import React from 'react';
import T from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';

import TsPenetrationChart from './TsPenetrationChart';
import TsPenetrationIndexChart from './TsPenetrationIndexChart';
import SectionError from '../../../_shared/components/SectionError';
import Tooltip from '../../../../../components/Tooltip';
import SimpleCard from '../../../../../components/Card/SimpleCard';
import OverPeriodDropdown from '../../../../../components/OverPeriodDropdown';
import { timeSpentPenetrationIndexSelector, timeSpentPenetrationSelector } from '../../selectors';
import { fetchTimeSpentPenetration } from '../../actions';
// import { ADVANCED_METRICS_APP_DESCRIPTION } from '../../../../utils/advanced-metrics';

const metricOption = {
  value: 'time_spent_penetration',
  label: 'Time Spent Penetration',
};

const TsPenetration = ({ isPress }) => {
  const dispatch = useDispatch();

  const { data, settings, filters } = useSelector(timeSpentPenetrationSelector);
  const tsPenetrationIndex = useSelector(timeSpentPenetrationIndexSelector);

  const handlePeriodChange = (value) => {
    dispatch(fetchTimeSpentPenetration({ change_type: value }));
  };

  if (settings.error) return <SectionError />;

  return (
    <SimpleCard
      headerLeft={
        <>
          <h3 className="h3 header-heading">AI Screen Time</h3>
          <p className="header-description">
            Shows how much of total user attention AI apps capture compared to all other apps in the
            panel. View trends over time and measure changes year over year or within the selected
            period.
          </p>
        </>
      }
      contentDisableGutters
      actionsLeft={<div className="highcharts-watermark" />}
      className="ts-penetration-card"
    >
      <div className="d-flex flex-column gap-16">
        <div className="section-body-header">
          <h4 className="section-body-header__title">
            Time Spent Penetration (index){' '}
            <Tooltip
              colorVariant="light"
              content="For each date, the total number of seconds spent inside that app on the most recent 7 days divided by the total number of seconds spent inside all apps on the most recent 7 days across the panel or data set. Indexed to 100 at the start of the period."
              overlayStyle={{ maxWidth: 324 }}
            >
              <i className="hicon-question-circle" />
            </Tooltip>
          </h4>
        </div>
        <TsPenetrationIndexChart
          metricOption={metricOption}
          series={tsPenetrationIndex.data}
          isPending={tsPenetrationIndex.settings.pending}
          isPress={isPress}
        />
      </div>
      <div className="d-flex flex-column gap-16">
        <div className="section-body-header align-items-start">
          <h4 className="section-body-header__title">
            Time Spent Penetration{' '}
            <Tooltip
              colorVariant="light"
              // content={ADVANCED_METRICS_APP_DESCRIPTION[metricOption.value]} // Dev note: using static TT text, as we show dashboard as prospect too.
              content="For each date, the total number of seconds spent inside that app on the most recent 7 days divided by the total number of seconds spent inside all apps on the most recent 7 days across the panel or data set"
              overlayStyle={{ maxWidth: 324 }}
            >
              <i className="hicon-question-circle" />
            </Tooltip>
          </h4>
          <OverPeriodDropdown
            selected={filters.change_type}
            disabled={settings.pending}
            menuAlign="end"
            onChange={handlePeriodChange}
          />
        </div>
        <TsPenetrationChart
          metricOption={metricOption}
          series={data}
          isPending={settings.pending}
          isPress={isPress}
        />
      </div>
    </SimpleCard>
  );
};

TsPenetration.propTypes = {
  isPress: T.bool,
};

export default TsPenetration;
